import * as Flags from "../../lib/Flags";

import { MenuItem } from "components/nav/MenuDropdown/MenuDropdown";

export const FOLDER_OPTIONS: MenuItem[] = [
	{
		id: "upload",
		displayName: "%controls_upload_title",
		pathName: "/upload",
		noRedirect: true,
		disabled: Flags.DEMO_MODE.is(),
	},
];

export const FILE_OPTIONS: MenuItem[] = [
	{
		id: "rename",
		displayName: "%misc_rename",
		pathName: "/rename",
		noRedirect: true,
		disabled: Flags.DEMO_MODE.is(),
	},
	{
		id: "delete",
		displayName: "%misc_delete",
		pathName: "/delete",
		noRedirect: true,
		disabled: Flags.DEMO_MODE.is(),
	},
];

export enum FILE_TYPES {
	CSV = "text/csv",
	EXCEL = "application/vnd.ms-excel",
	JSON = "application/json",
	PLAIN = "text/plain",
	HTML = "text/html",
	PDF = "application/pdf",
	RTF = "application/rtf",
	ZIP = "application/zip",
	GZIP = "application/gzip",
	SEVENZIP = "application/x-7z-compressed",
	XZIP = "application/x-zip-compressed",
	MD = "text/markdown",
	MDOLD = "text/x-markdown",
	MD_EXTENSION = ".md",
	JPEG = "image/jpeg",
	JPG = "image/jpg",
	PNG = "image/png",
	GIF = "image/gif",
	PRESENTATION = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	POWERPOINT = "application/vnd.ms-powerpoint",
	DOC = "application/msword",
	DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

export const VALID_FILE_TYPES_FAQ_LINK =
	"https://faq.brightmile.io/what-file-formats-are-supported-for-the-file-upload-tool";

export const FOLDER_KEEP = ".keep";
export const FOLDER_GLOBAL = "__global";
export const FOLDER_GLOBAL_DISPLAY_NAME = "Global";
export const FILE_LIST_ITEM_TRANSITION_TIME = 300;
